export default __webpack_public_path__ + "static/media/info.c911c86a.svg";